import "./config/sentry";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "@fontsource-variable/inter";

const oldDomain = location.hostname.match(/^cividocs(-staging)?\.web\.app$/i);
if (oldDomain) {
  const dev = oldDomain[1] ? "dev." : "";
  const port = location.port ? ":" + location.port : "";
  const path = location.pathname;
  const search = location.search;
  const hash = location.hash;
  location.href = `https://${dev}docs.civi.link${port}${path}${search}${hash}`;
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
